import React, { useContext, useEffect, useState } from "react"
import { Row, Col, Form, Tabs, Tab, ButtonGroup } from "react-bootstrap"
import DatePicker from "react-datepicker"
import { useNavigate } from "react-router-dom"
import moment from "moment"
import Navbar from "../../../Components/Navbar/Navbar"
import Table from "../../../Components/TableTemplate/DataTable"
import {
  numberFormat,
  selectDropdownStyle,
  toastStyle,
} from "../../../Helpers/Utils/Common"
import PurchaseOrderPicker from "./PurchaseOrderPicker"
import {
  deletePurchaseReturn,
  getAllPurchaseReturn,
  updateReplacementType,
} from "../../../Helpers/apiCalls/Purchases/purchaseReturnApi"
import DeleteModal from "../../../Components/Modals/DeleteModal"
import toast from "react-hot-toast"
import { getAllInvoices } from "../../../Helpers/apiCalls/Purchases/purchaseInvoiceApi"
import { getAllSuppliers } from "../../../Helpers/apiCalls/suppliersApi"
import Select from "react-select"
import ApproveModal from "../../../Components/Modals/ApproveModal"
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination"
import Footer from "../../../Components/Footer/Footer"
import { Context } from "../../../Helpers/Utils/Context"

export default function PurchaseReturn() {
  const { setDateFrom, setDateTo, dateFilter, currentTab, setCurrentTab } =
    useContext(Context)
  const navigateTo = useNavigate()
  const [inactive, setInactive] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const [showPicker, setShowPicker] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [showDeductModal, setShowDeductModal] = useState(false)
  const [isClicked, setIsClicked] = useState(false)
  const [selectedRow, setSelectedRow] = useState({})
  const [allInvoice, setAllInvoice] = useState([])
  const [suppliers, setSuppliers] = useState([])
  const today = new Date()
  const aweekago = new Date()
  aweekago.setDate(aweekago.getDate() - 7)
  const [tableData, setTableData] = useState([])
  const [filterConfig, setFilterConfig] = useState({
    term: "",
    tab: currentTab ? currentTab : "for approval",
    status: "for approval",
    return_status: "pending",
    page: 1,
    date_from: dateFilter.date_from ? dateFilter.date_from : "",
    date_to: dateFilter.date_to ? dateFilter.date_to : "",
  })
  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10 // Change this based on your requirement

  const handlePageChange = (page) => {
    setCurrentPage(page)
    setFilterConfig((prev) => ({
      ...prev,
      page: page,
    }))
  }

  const handleProceed = (poId) => {
    navigateTo("/purchasereturn/add/" + poId)
  }

  function handleSelectChange(e, row) {
    setSelectedRow(row)
    if (e.target.value === "edit") {
      navigateTo("/purchasereturn/edit/" + row.id)
    } else if (e.target.value === "print") {
      navigateTo("/purchasereturn/view/" + row.id)
    } else if (e.target.value === "delete") {
      setShowDeleteModal(true)
    } else if (e.target.value === "replace") {
      navigateTo("/purchasereplacement/add/" + row.id)
    }
  }

  function ActionBtn(row) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action"
        onChange={(e) => handleSelectChange(e, row)}
        value={""}
      >
        <option value="" hidden selected>
          Select
        </option>
        <option value="print" className="color-options">
          View
        </option>
        {filterConfig.tab === "for approval" && (
          <>
            <option value="edit" className="color-options">
              Edit
            </option>
            <option value="delete" className="color-red">
              Delete
            </option>
          </>
        )}
      </Form.Select>
    )
  }

  function ViewBtn(row) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        onClick={(e) => handleSelectChange(e, row)}
        value="print"
      >
        {filterConfig.tab === "for approval" ? "Review" : "View"}
      </button>
    )
  }

  function ReplaceBtn(row) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        onClick={(e) => handleSelectChange(e, row)}
        value="replace"
      >
        Replace
      </button>
    )
  }

  const handleTabSelect = (tabKey) => {
    setCurrentPage(1)
    setCurrentTab(tabKey)
    setFilterConfig((prev) => {
      return {
        ...prev,
        tab: tabKey,
        status:
          tabKey !== "all"
            ? tabKey === "incomplete" || tabKey === "complete"
              ? "approved"
              : tabKey === "for approval" || tabKey === "approved"
              ? tabKey
              : ""
            : "",
        return_status:
          tabKey !== "all"
            ? tabKey === "for approval" || tabKey === "approved"
              ? "pending"
              : tabKey === "incomplete"
              ? "incomplete"
              : tabKey === "complete"
              ? "complete"
              : ""
            : "",
        receive_id: "",
        supplier_id: "",
        replacement_type: tabKey === "approved" ? "pending" : "",
        date_from: dateFilter.date_from
          ? dateFilter.date_from
          : tabKey === "complete" || tabKey === "all"
          ? aweekago
          : "",
        date_to: dateFilter.date_to
          ? dateFilter.date_to
          : tabKey === "complete" || tabKey === "all"
          ? today
          : "",
        page: "1",
      }
    })
  }

  async function fetchTableData() {
    setShowLoader(true)
    setTableData([])
    setTotalItems(0)
    const response = await getAllPurchaseReturn(filterConfig)
    if (response.data) {
      const res = response.data.data.map((row) => {
        var info = row
        info.purchase_date = moment(row.purchase_date).format("MMM DD, YYYY")
        info.receive_date = moment(row.receive_date).format("MMM DD, YYYY")
        info.return_date = moment(row.return_date).format("MMM DD, YYYY")
        info.grand_total = numberFormat(row.grand_total)
        return info
      })
      setTotalItems(response.data.size)
      setTableData(res)
    }
    setShowLoader(false)
  }

  async function handleDelete() {
    if (!isClicked) {
      setIsClicked(true)
      const response = await deletePurchaseReturn(selectedRow.id)
      if (response.data) {
        toast.success(response.data.message, {
          style: toastStyle(),
        })
        setShowDeleteModal(false)
        fetchTableData()
      } else {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data)
        })
      }
      setIsClicked(false)
    }
  }

  // FUNCTION TO DEDUCT PAYMENT
  async function handleDeduct(type) {
    if (!isClicked) {
      setIsClicked(true)
      const response = await updateReplacementType(selectedRow.id, type)
      if (response.data) {
        toast.success(response.data.message, {
          style: toastStyle(),
        })
        setShowDeductModal(false)
        fetchTableData()
      } else {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data)
        })
        setShowDeductModal(false)
        fetchTableData()
      }
      setIsClicked(false)
    }
  }

  function InvoiceBtn(row) {
    return (
      <button
        type="button"
        className="button-secondary table-button me-3"
        onClick={() => handleViewInvoice(row.receive_id)}
      >
        {`INV. ${row.invoice_no}`}
      </button>
    )
  }
  function handleViewInvoice(id) {
    window.open("/purchaseinvoices/print/" + id, "_blank")
  }

  function DeductBtn(row) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        onClick={(e) => {
          setSelectedRow(row)
          setShowDeductModal(true)
        }}
      >
        Deduct
      </button>
    )
  }

  function ReplacementIdBtn(row) {
    if (row.replacement_ids) {
      return (
        <ButtonGroup vertical>
          <>
            {row.replacement_ids?.map((row) => {
              return (
                <button
                  type="button"
                  className="button-secondary table-button p-1"
                  onClick={() => handleViewReplacement(row)}
                >
                  {`NO.${row}`}
                </button>
              )
            })}
          </>
        </ButtonGroup>
      )
    }
  }
  function handleViewReplacement(id) {
    window.open("/purchasereplacement/view/" + id, "_blank")
  }

  async function fetchSuppliers() {
    setSuppliers([])

    const response = await getAllSuppliers()
    if (response.data) {
      var allData = response.data.data.map((supplier) => {
        var info = supplier
        info.label = supplier.trade_name
        info.value = supplier.id
        return info
      })
      setSuppliers([{ label: "All Suppliers", value: "" }, ...allData])
    }
  }

  async function fetchAllInvoice() {
    const response = await getAllInvoices()
    if (response.data) {
      setAllInvoice(response.data.data)
    }
  }

  const handleFilterChange = (e) => {
    const { name, value } = e.target
    setFilterConfig((prev) => {
      return {
        ...prev,
        [name]: value,
      }
    })
  }

  useEffect(() => {
    fetchAllInvoice()
    fetchSuppliers()
  }, [])

  useEffect(() => {
    fetchTableData()
  }, [filterConfig, currentPage])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"PURCHASES"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              PURCHASE RETURN{" "}
            </h1>
          </Col>
          <Col
            xs={12}
            lg={3}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3"
          >
            <input
              type="search"
              name="invoice_no"
              placeHolder="Search Invoice No/DR no.."
              className="search-bar"
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") && handleFilterChange(e)
              }
            />
          </Col>
          <Col lg={2} className="mt-3 mt-lg-0">
            <div className="PO-filters">
              <button className="add-btn" onClick={() => setShowPicker(true)}>
                Add
              </button>
            </div>
          </Col>
        </Row>

        <Tabs
          activeKey={filterConfig.tab}
          defaultActiveKey={filterConfig.tab}
          id="PO-tabs"
          onSelect={handleTabSelect}
        >
          <Tab eventKey="for approval" title="for approval">
            <div className="tab-content">
              <div className="mb-3" />
              <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                Filter By:
              </span>
              <Row className="PO-filters flex flex-row mx-2 my-1">
                <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                  <Select
                    className="dropsearch-filter"
                    classNamePrefix="react-select"
                    placeholder="Select Supplier"
                    styles={selectDropdownStyle}
                    options={suppliers}
                    onChange={(e) => {
                      setFilterConfig((prev) => {
                        return {
                          ...prev,
                          supplier_id: e.value,
                        }
                      })
                    }}
                  />
                </Col>
                <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                  <Form.Select
                    onChange={(e) =>
                      setFilterConfig((prev) => ({
                        ...prev,
                        receive_id: e.target.value,
                      }))
                    }
                    className="date-filter force-width w-full"
                  >
                    <option value="">All Invoices</option>
                    {allInvoice.map((row) => (
                      <option value={row.id}>{row.invoice_label}</option>
                    ))}
                  </Form.Select>
                </Col>
                <Col xs={6} lg={2}>
                  <DatePicker
                    autoComplete="off"
                    selected={filterConfig.date_from}
                    placeholderText={"Select Date from"}
                    name="date_from"
                    onChange={(date) => {
                      setDateFrom(moment(date).format("YYYY-MM-DD"))
                      setFilterConfig((prev) => {
                        return { ...prev, date_from: date }
                      })
                    }}
                    fixedHeight
                    className="date-filter me-4 form-control"
                    showYearDropdown
                    dateFormat="MMM dd, yyyy"
                    dateFormatCalendar="MMMM"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                  />
                </Col>
                <Col xs={6} lg={2}>
                  <DatePicker
                    autoComplete="off"
                    selected={filterConfig.date_to}
                    placeholderText={"Select Date to"}
                    name="date_to"
                    onChange={(date) => {
                      setDateTo(moment(date).format("YYYY-MM-DD"))
                      setFilterConfig((prev) => {
                        return { ...prev, date_to: date }
                      })
                    }}
                    minDate={filterConfig.date_from}
                    className="date-filter ps-label-content me-5 form-control"
                    showYearDropdown
                    dateFormat="MMM dd, yyyy"
                    dateFormatCalendar="MMMM"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                  />
                </Col>
              </Row>
              <div className="mb-2" />
              <TableWithDynamicPagination
                tableHeaders={[
                  "-",
                  // "RETURN ID",
                  "INV NO.",
                  "SUPPLIER",
                  "GRAND TOTAL",
                  "PURCHASE DATE",
                  "RECEIVED DATE",
                  "RETURN DATE",
                  // "STATUS",
                  "ACTIONS",
                ]}
                headerSelector={[
                  "-",
                  // "id",
                  "invoice_no",
                  "supplier_name",
                  "grand_total",
                  "purchase_date",
                  "receive_date",
                  "return_date",
                  // "status",
                ]}
                tableData={tableData}
                ActionBtn={(row) => ActionBtn(row)}
                ViewBtn={(row) => ViewBtn(row)}
                newTabBtn={(row) => InvoiceBtn(row)}
                tableType={"purchase return"}
                showLoader={showLoader}
                // used in dynamic pagination
                totalItems={totalItems}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                handlePageChange={handlePageChange}
              />
            </div>
          </Tab>
          <Tab eventKey="approved" title="approved">
            <div className="tab-content">
              <div className="mb-3" />
              <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                Filter By:
              </span>
              <Row className="PO-filters flex flex-row mx-2 my-1">
                <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                  <Select
                    className="dropsearch-filter"
                    classNamePrefix="react-select"
                    placeholder="Select Supplier"
                    styles={selectDropdownStyle}
                    options={suppliers}
                    onChange={(e) => {
                      setFilterConfig((prev) => {
                        return {
                          ...prev,
                          supplier_id: e.value,
                        }
                      })
                    }}
                  />
                </Col>
                <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                  <Form.Select
                    onChange={(e) =>
                      setFilterConfig((prev) => ({
                        ...prev,
                        receive_id: e.target.value,
                      }))
                    }
                    className="date-filter force-width w-full"
                  >
                    <option value="">All Invoices</option>
                    {allInvoice.map((row) => (
                      <option value={row.id}>{row.invoice_label}</option>
                    ))}
                  </Form.Select>
                </Col>
                <Col xs={6} lg={2}>
                  <DatePicker
                    autoComplete="off"
                    selected={filterConfig.date_from}
                    placeholderText={"Select Date from"}
                    name="date_from"
                    onChange={(date) => {
                      setDateFrom(moment(date).format("YYYY-MM-DD"))
                      setFilterConfig((prev) => {
                        return { ...prev, date_from: date }
                      })
                    }}
                    fixedHeight
                    className="date-filter me-4 form-control"
                    showYearDropdown
                    dateFormat="MMM dd, yyyy"
                    dateFormatCalendar="MMMM"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                  />
                </Col>
                <Col xs={6} lg={2}>
                  <DatePicker
                    autoComplete="off"
                    selected={filterConfig.date_to}
                    placeholderText={"Select Date to"}
                    name="date_to"
                    onChange={(date) => {
                      setDateTo(moment(date).format("YYYY-MM-DD"))
                      setFilterConfig((prev) => {
                        return { ...prev, date_to: date }
                      })
                    }}
                    minDate={filterConfig.date_from}
                    className="date-filter ps-label-content me-5 form-control"
                    showYearDropdown
                    dateFormat="MMM dd, yyyy"
                    dateFormatCalendar="MMMM"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                  />
                </Col>
              </Row>
              <div className="mb-2" />
              <TableWithDynamicPagination
                tableHeaders={[
                  "-",
                  "/",
                  // "RETURN ID",
                  "INV NO.",
                  "SUPPLIER",
                  "GRAND TOTAL",
                  "PURCHASE DATE",
                  "RECEIVED DATE",
                  "RETURN DATE",
                  // "STATUS",
                  "ACTIONS",
                ]}
                headerSelector={[
                  "-",
                  "/",
                  // "id",
                  "invoice_no",
                  "supplier_name",
                  "grand_total",
                  "purchase_date",
                  "receive_date",
                  "return_date",
                  // "status",
                ]}
                tableData={tableData}
                ActionBtn={(row) => ActionBtn(row)}
                newTabBtn={(row) => InvoiceBtn(row)}
                ViewBtn={(row) => ReplaceBtn(row)}
                DoneBtn={(row) => DeductBtn(row)}
                tableType={"purchase return"}
                showLoader={showLoader}
                // used in dynamic pagination
                totalItems={totalItems}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                handlePageChange={handlePageChange}
              />
            </div>
          </Tab>
          <Tab eventKey="incomplete" title="incomplete">
            <div className="tab-content">
              <div className="mb-3" />
              <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                Filter By:
              </span>
              <Row className="PO-filters flex flex-row mx-2 my-1">
                <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                  <Select
                    className="dropsearch-filter"
                    classNamePrefix="react-select"
                    placeholder="Select Supplier"
                    styles={selectDropdownStyle}
                    options={suppliers}
                    onChange={(e) => {
                      setFilterConfig((prev) => {
                        return {
                          ...prev,
                          supplier_id: e.value,
                        }
                      })
                    }}
                  />
                </Col>
                <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                  <Form.Select
                    onChange={(e) =>
                      setFilterConfig((prev) => ({
                        ...prev,
                        receive_id: e.target.value,
                      }))
                    }
                    className="date-filter force-width w-full"
                  >
                    <option value="">All Invoices</option>
                    {allInvoice.map((row) => (
                      <option value={row.id}>{row.invoice_label}</option>
                    ))}
                  </Form.Select>
                </Col>
                <Col xs={6} lg={2}>
                  <DatePicker
                    autoComplete="off"
                    selected={filterConfig.date_from}
                    placeholderText={"Select Date from"}
                    name="date_from"
                    onChange={(date) => {
                      setDateFrom(moment(date).format("YYYY-MM-DD"))
                      setFilterConfig((prev) => {
                        return { ...prev, date_from: date }
                      })
                    }}
                    fixedHeight
                    className="date-filter me-4 form-control"
                    showYearDropdown
                    dateFormat="MMM dd, yyyy"
                    dateFormatCalendar="MMMM"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                  />
                </Col>
                <Col xs={6} lg={2}>
                  <DatePicker
                    autoComplete="off"
                    selected={filterConfig.date_to}
                    placeholderText={"Select Date to"}
                    name="date_to"
                    onChange={(date) => {
                      setDateTo(moment(date).format("YYYY-MM-DD"))
                      setFilterConfig((prev) => {
                        return { ...prev, date_to: date }
                      })
                    }}
                    minDate={filterConfig.date_from}
                    className="date-filter ps-label-content me-5 form-control"
                    showYearDropdown
                    dateFormat="MMM dd, yyyy"
                    dateFormatCalendar="MMMM"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                  />
                </Col>
              </Row>
              <div className="mb-2" />
              <TableWithDynamicPagination
                tableHeaders={[
                  "-",
                  "^",
                  "/",
                  // "RETURN ID",
                  "INV NO.",
                  "REPLACEMENT ID",
                  "SUPPLIER",
                  "GRAND TOTAL",
                  "PURCHASE DATE",
                  "RECEIVED DATE",
                  "RETURN DATE",
                  // "STATUS",
                  "ACTIONS",
                ]}
                headerSelector={[
                  "-",
                  "^",
                  "/",
                  // "id",
                  "invoice_no",
                  "replacement_id",
                  "supplier_name",
                  "grand_total",
                  "purchase_date",
                  "receive_date",
                  "return_date",
                  // "status",
                ]}
                tableData={tableData}
                ActionBtn={(row) => ActionBtn(row)}
                ViewBtn={(row) => ViewBtn(row)}
                newTabBtn={(row) => InvoiceBtn(row)}
                PendingBtn={(row) => ReplacementIdBtn(row)}
                ContractBtn={(row) => ReplaceBtn(row)}
                DoneBtn={(row) => DeductBtn(row)}
                tableType={"purchase return"}
                showLoader={showLoader}
                // used in dynamic pagination
                totalItems={totalItems}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                handlePageChange={handlePageChange}
              />
            </div>
          </Tab>
          <Tab eventKey="complete" title="completed">
            <div className="tab-content">
              <div className="mb-3" />
              <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                Filter By:
              </span>
              <Row className="PO-filters flex flex-row mx-2 my-1">
                <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                  <Select
                    className="dropsearch-filter"
                    classNamePrefix="react-select"
                    placeholder="Select Supplier"
                    styles={selectDropdownStyle}
                    options={suppliers}
                    onChange={(e) => {
                      setFilterConfig((prev) => {
                        return {
                          ...prev,
                          supplier_id: e.value,
                        }
                      })
                    }}
                  />
                </Col>
                <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                  <Form.Select
                    onChange={(e) =>
                      setFilterConfig((prev) => ({
                        ...prev,
                        receive_id: e.target.value,
                      }))
                    }
                    className="date-filter force-width w-full"
                  >
                    <option value="">All Invoices</option>
                    {allInvoice.map((row) => (
                      <option value={row.id}>{row.invoice_label}</option>
                    ))}
                  </Form.Select>
                </Col>
                <Col xs={6} lg={2}>
                  <DatePicker
                    autoComplete="off"
                    selected={filterConfig.date_from}
                    placeholderText={"Select Date from"}
                    name="date_from"
                    onChange={(date) => {
                      setDateFrom(moment(date).format("YYYY-MM-DD"))
                      setFilterConfig((prev) => {
                        return { ...prev, date_from: date }
                      })
                    }}
                    fixedHeight
                    className="date-filter me-4 form-control"
                    showYearDropdown
                    dateFormat="MMM dd, yyyy"
                    dateFormatCalendar="MMMM"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                  />
                </Col>
                <Col xs={6} lg={2}>
                  <DatePicker
                    autoComplete="off"
                    selected={filterConfig.date_to}
                    placeholderText={"Select Date to"}
                    name="date_to"
                    onChange={(date) => {
                      setDateTo(moment(date).format("YYYY-MM-DD"))
                      setFilterConfig((prev) => {
                        return { ...prev, date_to: date }
                      })
                    }}
                    minDate={filterConfig.date_from}
                    className="date-filter ps-label-content me-5 form-control"
                    showYearDropdown
                    dateFormat="MMM dd, yyyy"
                    dateFormatCalendar="MMMM"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                  />
                </Col>
              </Row>
              <div className="mb-2" />
              <TableWithDynamicPagination
                tableHeaders={[
                  "-",
                  // "RETURN ID",
                  "INV NO.",
                  "REPLACEMENT ID",
                  "SUPPLIER",
                  "GRAND TOTAL",
                  "PURCHASE DATE",
                  "RECEIVED DATE",
                  "RETURN DATE",
                  // "STATUS",
                  // "ACTIONS",
                ]}
                headerSelector={[
                  "-",
                  // "id",
                  "invoice_no",
                  "replacement_id",
                  "supplier_name",
                  "grand_total",
                  "purchase_date",
                  "receive_date",
                  "return_date",
                  // "status",
                ]}
                tableData={tableData}
                // ActionBtn={(row) => ActionBtn(row)}
                ViewBtn={(row) => ViewBtn(row)}
                newTabBtn={(row) => InvoiceBtn(row)}
                PendingBtn={(row) => ReplacementIdBtn(row)}
                tableType={"purchase return"}
                showLoader={showLoader}
                // used in dynamic pagination
                totalItems={totalItems}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                handlePageChange={handlePageChange}
              />
            </div>
          </Tab>
          <Tab eventKey="all" title="all">
            <div className="tab-content">
              <div className="mb-3" />
              <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                Filter By:
              </span>
              <Row className="PO-filters flex flex-row mx-2 my-1">
                <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                  <Select
                    className="dropsearch-filter"
                    classNamePrefix="react-select"
                    placeholder="Select Supplier"
                    styles={selectDropdownStyle}
                    options={suppliers}
                    onChange={(e) => {
                      setFilterConfig((prev) => {
                        return {
                          ...prev,
                          supplier_id: e.value,
                        }
                      })
                    }}
                  />
                </Col>
                <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                  <Form.Select
                    onChange={(e) =>
                      setFilterConfig((prev) => ({
                        ...prev,
                        receive_id: e.target.value,
                      }))
                    }
                    className="date-filter force-width w-full"
                  >
                    <option value="">All Invoices</option>
                    {allInvoice.map((row) => (
                      <option value={row.id}>{row.invoice_label}</option>
                    ))}
                  </Form.Select>
                </Col>
                <Col xs={6} lg={2}>
                  <DatePicker
                    autoComplete="off"
                    selected={filterConfig.date_from}
                    placeholderText={"Select Date from"}
                    name="date_from"
                    onChange={(date) => {
                      setDateFrom(moment(date).format("YYYY-MM-DD"))
                      setFilterConfig((prev) => {
                        return { ...prev, date_from: date }
                      })
                    }}
                    fixedHeight
                    className="date-filter me-4 form-control"
                    showYearDropdown
                    dateFormat="MMM dd, yyyy"
                    dateFormatCalendar="MMMM"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                  />
                </Col>
                <Col xs={6} lg={2}>
                  <DatePicker
                    autoComplete="off"
                    selected={filterConfig.date_to}
                    placeholderText={"Select Date to"}
                    name="date_to"
                    onChange={(date) => {
                      setDateTo(moment(date).format("YYYY-MM-DD"))
                      setFilterConfig((prev) => {
                        return { ...prev, date_to: date }
                      })
                    }}
                    minDate={filterConfig.date_from}
                    className="date-filter ps-label-content me-5 form-control"
                    showYearDropdown
                    dateFormat="MMM dd, yyyy"
                    dateFormatCalendar="MMMM"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                  />
                </Col>
              </Row>
              <div className="mb-2" />
              <TableWithDynamicPagination
                tableHeaders={[
                  "-",
                  // "RETURN ID",
                  "INV NO.",
                  "REPLACEMENT ID",
                  "SUPPLIER",
                  "GRAND TOTAL",
                  "PURCHASE DATE",
                  "RECEIVED DATE",
                  "RETURN DATE",
                  "STATUS",
                  // "ACTIONS",
                ]}
                headerSelector={[
                  "-",
                  // "id",
                  "invoice_no",
                  "replacement_id",
                  "supplier_name",
                  "grand_total",
                  "purchase_date",
                  "receive_date",
                  "return_date",
                  "status",
                ]}
                tableData={tableData}
                // ActionBtn={(row) => ActionBtn(row)}
                ViewBtn={(row) => ViewBtn(row)}
                newTabBtn={(row) => InvoiceBtn(row)}
                PendingBtn={(row) => ReplacementIdBtn(row)}
                tableType={"purchase return"}
                showLoader={showLoader}
                // used in dynamic pagination
                totalItems={totalItems}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                handlePageChange={handlePageChange}
              />
            </div>
          </Tab>
        </Tabs>

        <PurchaseOrderPicker
          header={"ADD PURCHASE RETURN"}
          hide={() => setShowPicker(false)}
          show={showPicker}
          proceed={handleProceed}
        />
        <DeleteModal
          show={showDeleteModal}
          onHide={() => setShowDeleteModal(false)}
          text="purchase return"
          onDelete={handleDelete}
          isClicked={isClicked}
        />
        <ApproveModal
          show={showDeductModal}
          hide={() => setShowDeductModal(false)}
          type="approve"
          text="deduct payment from Returned Items"
          handler={() => handleDeduct("deduction")}
          isClicked={isClicked}
        />
      </div>
      <Footer />
    </div>
  )
}
